import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const AgeGate = ({ isOpen, onClose }) => {
  const [birthDate, setBirthDate] = useState({ month: '', day: '', year: '' });
  const [error, setError] = useState('');

  const handleVerifyAge = () => {
    const { month, day, year } = birthDate;
    
    if (!month || !day || !year) {
      setError('Please enter your complete date of birth');
      return;
    }

    const birthDateObj = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }

    if (age >= 21) {
      localStorage.setItem('ageVerified', 'true');
      onClose();
    } else {
      setError('You must be 21 or older to access this site');
    }
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md bg-white">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/mvt79ma9_29A81CA4-6157-450E-BDCF-09CA0369D517.png"
              alt="Big Dog Kush" 
              className="h-20 mx-auto mb-4"
            />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Age Verification Required</h2>
            <p className="text-gray-600 mb-6">You must be 21+ to enter this site</p>
          </div>

          <div className="mb-6">
            <p className="text-sm text-gray-700 mb-4">Please enter your date of birth:</p>
            <div className="flex gap-2 justify-center">
              <select 
                className="px-3 py-2 border rounded-lg"
                value={birthDate.month}
                onChange={(e) => setBirthDate({...birthDate, month: e.target.value})}
              >
                <option value="">Month</option>
                {Array.from({length: 12}, (_, i) => (
                  <option key={i + 1} value={i + 1}>{String(i + 1).padStart(2, '0')}</option>
                ))}
              </select>
              
              <select 
                className="px-3 py-2 border rounded-lg"
                value={birthDate.day}
                onChange={(e) => setBirthDate({...birthDate, day: e.target.value})}
              >
                <option value="">Day</option>
                {Array.from({length: 31}, (_, i) => (
                  <option key={i + 1} value={i + 1}>{String(i + 1).padStart(2, '0')}</option>
                ))}
              </select>
              
              <select 
                className="px-3 py-2 border rounded-lg"
                value={birthDate.year}
                onChange={(e) => setBirthDate({...birthDate, year: e.target.value})}
              >
                <option value="">Year</option>
                {Array.from({length: 80}, (_, i) => {
                  const year = new Date().getFullYear() - i;
                  return <option key={year} value={year}>{year}</option>;
                })}
              </select>
            </div>
          </div>

          {error && (
            <div className="mb-4 text-red-600 text-sm">{error}</div>
          )}

          <div className="flex gap-3 justify-center">
            <Button 
              onClick={handleVerifyAge}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-2"
            >
              Enter
            </Button>
            <Button 
              onClick={handleExit}
              variant="outline"
              className="px-8 py-2"
            >
              Exit
            </Button>
          </div>

          <p className="text-xs text-gray-500 mt-4">
            This website contains cannabis-related content intended for adults 21+
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AgeGate;